




import React, { useMemo } from "react";
import { Box, CircularProgress, Typography, useTheme } from "@mui/material";
import { format } from "date-fns";


import { useRank } from "../../hooks/useRank";
import DataCard from "@shared/ui/data-cards/DataCard";

interface ProductImpressionsProps {
    rankId: string;
}


const ProductImpressions: React.FC<ProductImpressionsProps> = ({ rankId }) => {

    const theme = useTheme();

    const { rank, isLoading, error } = useRank(rankId);

    const chartData = useMemo(() => {
        if (!rank?.dailyProductRanks) return [];

        // Filter by the specified component type
        const dailyProductRanks = rank.dailyProductRanks
            .sort((a, b) => a.date.getTime() - b.date.getTime())
            .map(dailyProductRank => ({
                date: format(dailyProductRank.date, 'yyyy-MM-dd'),
                value: dailyProductRank.impressions ?? null,
            }))
            .filter(item => item.value !== null);

        return dailyProductRanks;
    }, [rank]);

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height={300}>
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height={300}>
                <Typography color="error">Failed to load forecast</Typography>
            </Box>
        );
    }

    if (!chartData || chartData.length === 0) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height={300}>
                <Typography color="text.secondary">No rank data available</Typography>
            </Box>
        );
    }

    return (
        <DataCard
            chartData={chartData}
            name="Impressions"
        />
    );
};

export default ProductImpressions;

